import { composeCouponRouteTemplate } from '@/lib/coupon/gen-code'
import { DEFAULT_POS_AMOUNT_COUPON } from '@/providers/coupon/PosAmountProvider'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/coupon/pos-amount')(
  composeCouponRouteTemplate(DEFAULT_POS_AMOUNT_COUPON),
)
